import React, { Fragment } from "react";
// import { useSelector } from "react-redux";
import { CloseButton } from "../../commonElements/button";
// import { roomSelector } from "../rooms/roomSlice";

const PetPolicy = ({ handleClose }) => {
  //   const { petPolicy } = useSelector(roomSelector);
  return (
    <Fragment>
      <div
        onClick={(e) => e.stopPropagation()}
        className="w-full p-6 m-auto bg-white  shadow-md max-w-xl relative mx-5"
      >
        <div className="right-0 absolute mr-6">
          <CloseButton handleClose={handleClose} />
        </div>

        <h1 className="font-normal text-center text-black mt-[2.75rem] text-xl">
          PET POLICY
        </h1>

        <p className="font-light text-black text-justify m-5">
          Guests may bring a maximum of 2 canine companions weighing a maximum
          of 50 pounds each. Felines and other animal species are prohibited. A
          $125 non-refundable pet fee will be assessed per pet at the time of
          check-in. Service Animals exempt. Please schedule a specific time to
          schedule room cleaning upon arrival with the Front Desk. Housekeeping
          is prohibited from entering guest rooms with pets when pet owners are
          not present.
        </p>
      </div>
    </Fragment>
  );
};

export default PetPolicy;
